import { render, staticRenderFns } from "./KinInfo.vue?vue&type=template&id=9583e944&scoped=true&"
import script from "./KinInfo.vue?vue&type=script&lang=js&"
export * from "./KinInfo.vue?vue&type=script&lang=js&"
import style0 from "./KinInfo.vue?vue&type=style&index=0&id=9583e944&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9583e944",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VContainer,VSimpleTable})
